import { IconButton } from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import type { DocumentViews } from "../../../../api/types/documentActivityTypes";
import useClientContext from "../../../../context/useClientContext";
import AnalyticsIcon from "@entrilia/shared/icons/AnalyticsIcon";
import { pageRoutes } from "../../../../routes";
import { getReferrerLocationState } from "../../../../utilities/navigationHelper";

interface Props {
  row: DocumentViews;
}

const DocumentViewsGridActionsCell = ({ row }: Props) => {
  const { clientCode } = useClientContext();
  const location = useLocation();
  const navigate = useNavigate();

  const {
    postMessageRequestId,
    userInfo: { contactId },
    fundraisingId,
    documentInfo: { attachmentId, fundraisingDocumentId },
  } = row;

  const getNavigationPath = () => {
    if (contactId && postMessageRequestId && attachmentId) {
      return `/${clientCode}/${pageRoutes.investorRelations}/${pageRoutes.contacts}/${contactId}/${pageRoutes.messages}/${postMessageRequestId}/${pageRoutes.documents}/${attachmentId}/${pageRoutes.activity}`;
    }

    if (contactId && fundraisingId && fundraisingDocumentId) {
      return `/${clientCode}/${pageRoutes.investorRelations}/${pageRoutes.contacts}/${contactId}/${pageRoutes.fundraisings}/${fundraisingId}/${pageRoutes.documents}/${fundraisingDocumentId}/${pageRoutes.activity}`;
    }

    return undefined;
  };

  const navigationPath = getNavigationPath();
  if (!navigationPath) {
    return null;
  }

  return (
    <IconButton
      onClick={(e) => {
        e.stopPropagation();
        navigate(navigationPath, { state: getReferrerLocationState(location) });
      }}
    >
      <AnalyticsIcon />
    </IconButton>
  );
};

export default DocumentViewsGridActionsCell;
